import { render, staticRenderFns } from "./NsBr.vue?vue&type=template&id=e36d2532"
import script from "./NsBr.vue?vue&type=script&lang=js"
export * from "./NsBr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports